var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"template-wrap"},[_c('pre',{staticClass:"h1_title"},[_vm._v(_vm._s(_vm.c.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }